import { render, staticRenderFns } from "./choiceSubject.vue?vue&type=template&id=584d42e5&scoped=true"
import script from "./choiceSubject.vue?vue&type=script&lang=js"
export * from "./choiceSubject.vue?vue&type=script&lang=js"
import style0 from "./choiceSubject.vue?vue&type=style&index=0&id=584d42e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d42e5",
  null
  
)

export default component.exports